/**
 * a list of colors to be accessed
 */
export const Colors={
    light_grey:"#F5F5F5",
    grey:"#e3e3e3",
    dark_grey:'rgba(125,125,125,1)',
    white:"#FFF",
    blue:"#0043A1",
    light_blue:"#3399CC",
    red:"#EE2222",
    black:'#000',
    green:'#00D78C',
    fadout_white:"#FFFFFF90"
}